<template>
  <div class="appt-book">
    <div id="success-details" style="display:none;"><input id="success-email" type="hidden" :value="$store.state.user.email"></div>
    <div class="book-title"><p v-html="response.responseHeadline"></p></div>
    <div class="book-description">
      <p class="appt-text-subhead"><span v-html="response.responseMessage"></span></p>
      <p class="appt-text-details"><span v-html="response.responseDetails"></span></p>
      <p class="appointment-phone-confirmation">
        <span class="call-now-cta">Questions? Call Now: </span>
        <a :href="'tel:'+storePhone" class="appt-store-phone">{{storePhone}}</a>
      </p>
    </div>
    <div class="book-btn" @click="exitModal">BROWSE OUR SITE</div>
  </div>
</template>

<script>
export default {
  props: {
    title: String
  },
  computed: {
    response() {
      return this.$store.state.form_response;
    },
    store(){
      return this.$store.state.user.store;
    },
    storePhone(){
      return this.$store.getters.getUserStorePhone;
    }
  },
  methods: {
    gotoEdit:function(index){
      this.$emit('goToEdit',index);
    },
    exitModal(){
      this.$emit('closeModal');
    }
  }
}
</script>